import { useEffect, useState } from 'react';

/**
 * Web-specific online status detection hook.
 * Listens to window 'online' and 'offline' events.
 * 
 * @returns {{ online: boolean }} - Whether the device is online
 */
export function useOnlineStatus(): { online: boolean } {
  const [online, setOnline] = useState(() => typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { online };
}
